import React from "react";
import ThemeToggle from "./theme-toggle";

interface MobileMenuHeaderProps {
  isDarkMode: boolean;
  onThemeToggle: () => void;
  onClose: () => void;
}

/**
 * Header bar for the mobile menu overlay.
 * Contains "Menu" label, theme toggle, and close button.
 */
const MobileMenuHeader: React.FC<MobileMenuHeaderProps> = ({
  isDarkMode,
  onThemeToggle,
  onClose,
}) => {
  return (
    <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700">
      <span className="text-sm font-medium text-gray-500 dark:text-gray-400">Menu</span>
      <div className="flex items-center space-x-2">
        {/* Theme Toggle */}
        <ThemeToggle isDarkMode={isDarkMode} onToggle={onThemeToggle} size="sm" />
        {/* Close Button */}
        <button
          onClick={onClose}
          className="flex items-center justify-center min-w-[44px] min-h-[44px] p-2 rounded-lg text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:bg-gray-700 transition-colors"
          aria-label="Close menu"
        >
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default MobileMenuHeader;
